import { request } from "~/client/http/FileController";

export const GetVersionConfig = async () => {
  const testHost = "http://82.146.53.133";
  const host = window.location.origin;
  const resolveHost = host === "http://localhost:8080" ? testHost : host;

  const res = await request.get(`${resolveHost}/api/v1/system-settings/config`);
  return res.data;
};
